import { useMemo } from "react";

import { DEFAULT_AXIS_FONT_WEIGHT, DEFAULT_FONT_SIZE } from "constants/chart.constants";
import { THEME_FONT_FAMILY } from "constants/style.constants";
import { useDashboardScreenshotStore } from "stores/dashboardScreenshot/useDashboardScreenshotStore";

import { IChartScreenshotSettings } from "models/chart";
import { WidgetComponentType } from "models/screenshot";

import {
  useScreenshotContext,
  useScreenshotPresetContext
} from "components/screenshot/hooks";

function useMPCScreenshotCalculatedDefaults(): IChartScreenshotSettings {
  // hooks
  const { widget, widgetState } = useScreenshotContext();
  const { selectedPreset: preset } = useScreenshotPresetContext();
  const dashboardWidgets = useDashboardScreenshotStore((s) => s.activeWidgets);
  const dashboardHasMPC = dashboardWidgets.some((w) => w.type === "multiphase-chart");

  return useMemo(() => {
    const isMPC = widget?.widgetComponentType === WidgetComponentType.Mpc;
    const isDashboardWithMPC =
      widget?.widgetComponentType === WidgetComponentType.Dashboard && dashboardHasMPC;

    return !isMPC && !isDashboardWithMPC
      ? {}
      : {
          axisFontSize: preset?.axisFontSize,
          titleFontSize: preset?.titleFontSize,
          axisLabelFontSize: preset?.axisLabelFontSize,
          titleText: widgetState?.chartSettings?.data?.title,
          axisFontWeight: DEFAULT_AXIS_FONT_WEIGHT,
          legendVisible: true,
          legendFontSize: preset?.legendFontSize ?? DEFAULT_FONT_SIZE,
          legendOpacity: 1,
          fontFamily: THEME_FONT_FAMILY,
          legendType: widgetState?.chartSettings?.legend?.type ?? "bottom",
          legendPosition: widgetState?.chartSettings?.legend?.position,
          applyAbbreviations: false
        };
  }, [
    widget?.widgetComponentType,
    dashboardHasMPC,
    preset?.axisFontSize,
    preset?.titleFontSize,
    preset?.axisLabelFontSize,
    preset?.legendFontSize,
    widgetState?.chartSettings?.data?.title,
    widgetState?.chartSettings?.legend?.type,
    widgetState?.chartSettings?.legend?.position
  ]);
}

export default useMPCScreenshotCalculatedDefaults;
